// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"41":"error","966":"dashboard"}[chunkId] || chunkId) + "." + {"2":"e54ccb19","41":"0cb4ff25","251":"e643c8fa","381":"de01b221","681":"f63d9362","793":"6128ed9c","966":"8f3c45fe"}[chunkId] + ".css";
};